import cx from "classnames";
import Link from "next/link";
import { FC } from "react";

import st from "./blog-filter.module.scss";
import { BlogFilterCategory } from "./BlogHomepageContent";
import { useTranslationContext } from "context/translation";

interface BlogFilterProps {
  filterCategories?: BlogFilterCategory[];
  selectedCategory?: string | null;
}

const BlogFilter: FC<BlogFilterProps> = ({
  filterCategories,
  selectedCategory,
}) => {
  const { all } = useTranslationContext();

  return (
    <nav className={st.container}>
      {filterCategories && (
        <>
          <Link
            className={cx(
              st.filterItem,
              !!selectedCategory && st.inactiveFilter,
            )}
            href={`/blog/`}
          >
            {all}
          </Link>
          {filterCategories.map((category, index) => (
            <Link
              className={cx(
                st.filterItem,
                category.slug !== selectedCategory && st.inactiveFilter,
              )}
              href={`/blog/${category.slug}`}
              key={index}
            >
              {category.filterText}
            </Link>
          ))}
        </>
      )}
    </nav>
  );
};

export default BlogFilter;
